export default "__VITE_ASSET__BT9Arb0u__"